module.exports = __webpack_public_path__ + "img/introduction_banner.f3b6d0e3.png";